import c1 from './images/c1.jpg';
import c2 from './images/c2.jpg';
import c3 from './images/c3.jpg';
import b1 from './images/b1.jpg';
import b2 from './images/b2.jpg';
import b3 from './images/b3.jpg';
import b4 from './images/b4.jpg';
import b5 from './images/b5.jpg';
import b6 from './images/b6.jpg';
import b7 from './images/b7.jpg';
import b8 from './images/b8.jpg';
import b9 from './images/b9.jpg';

export const navBar = [
  {
    id: 1,
    name: "Discover",
    path: "/",
  },
  {
    id: 2,
    name: "Browser",
    path: "/browser",
  },
  {
    id: 3,
    name: "Charts",
    path: "/charts",
  },
  {
    id: 4,
    name: "Artists",
    path: "/artists",
  },
]
export const hero1 = [
  {
    id: 1,
    name: "New Album from Nouvelle",
    tag: "Nouvelle",
    cover: c1,
  },
  {
    id: 2,
    name: "Bind Me",
    tag: "Fifty",
    cover: c2,
  },
  {
    id: 3,
    name: "New Track from Pablo Nouvelle",
    tag: "Pablo Nouvelle",
    cover: c3,
  },
]
export const hero2 = [
  {
    id: 1,
    name: "Pull Up",
    tag: "Summerella",
    cover: b4,
  },
  {
    id: 2,
    name: "Fireworks",
    tag: "Kygo",
    cover: b1,
  },
  {
    id: 3,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b2,
  },
  {
    id: 4,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
]
export const trending = [
  {
    id: 1,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 2,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b2,
  },
  {
    id: 3,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover:b5,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b6,
  },
  {
    id: 5,
    name: "Fireworks",
    tag: "Kygo",
    cover: b1,
  },
  {
    id: 6,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b7,
  },
]
export const news = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b7,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b8,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b9,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b6,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b2,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b4,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b5,
  },
]

export const recommend = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b1,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b2,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b3,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b4,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b5,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b6,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b7,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b8,
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b2,
  },
]

export const browse = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b1,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b2,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b3,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b4,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b5,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b6,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b7,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b8,
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b2,
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b7,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b8,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b9,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b6,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b2,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b4,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b5,
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b1,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b2,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b3,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b4,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b5,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b6,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b7,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b8,
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b2,
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: b7,
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: b8,
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: b9,
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: b6,
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: b2,
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: b4,
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: b3,
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: b5,
  },
]